import { render, staticRenderFns } from "./fang.vue?vue&type=template&id=8c932e2a&scoped=true"
import script from "./fang.vue?vue&type=script&lang=js"
export * from "./fang.vue?vue&type=script&lang=js"
import style0 from "./fang.vue?vue&type=style&index=0&id=8c932e2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c932e2a",
  null
  
)

export default component.exports